import React from 'react';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import Auth0ProviderWithRouter from './Auth0ProviderWithRouter';
import { UserProvider } from './context/UserContext';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Router>
    <Auth0ProviderWithRouter>
      <UserProvider>
        <App />
      </UserProvider>
    </Auth0ProviderWithRouter>
  </Router>
);
